import { render } from "./ApprovalList.vue?vue&type=template&id=788b5f85&scoped=true&ts=true"
import script from "./ApprovalList.vue?vue&type=script&lang=ts"
export * from "./ApprovalList.vue?vue&type=script&lang=ts"

import "./ApprovalList.vue?vue&type=style&index=0&id=788b5f85&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-788b5f85"]])

export default __exports__